import { Capacitor } from '@capacitor/core';
import { initializeApp } from 'firebase/app';
import { getAuth, indexedDBLocalPersistence, initializeAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getFirestore } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

export const storage = getStorage(app);
export const database = getDatabase(app);
export const firestore = getFirestore(app);
export const functions = getFunctions(app, 'europe-west1');

// Connect to Firebase Functions emulator in development
if (import.meta.env.VITE_USE_EMULATOR === 'true') {
  try {
    connectFunctionsEmulator(functions, 'localhost', 5001);
    console.log('🔥 Connected to Firebase Functions Emulator');
  } catch (error) {
    console.warn('Failed to connect to Functions Emulator:', error);
  }
}

let authInstance: any = null;

if (Capacitor.isNativePlatform()) {
  authInstance = initializeAuth(app, { persistence: indexedDBLocalPersistence });
} else {
  authInstance = getAuth(app);
}

export const firebaseAuth = authInstance;
